var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7c0 4.6 5.1 6.7 7.5 10.1.2.3.8.3 1 0C12.9 13.7 18 11.6 18 7c0-2-1.5-4-4-4-2.1 0-3.2 1.1-3.7 2.3-.1.2-.4.2-.5 0C9.2 4.1 8.1 3 6 3 3.5 3 2 5 2 7z"
  })));
};
export default SvgHeart;